(function($) {
	$(document).ready(function(){
		//Init View Controller
		$('body').ViewController({'titleSuffix':sitename});
		$('.do-container-sized:not(.is-container-sized)').FullSize({});
		$('.loader').Loader({});

		// $('.top-menu-search-link').on('click', function(e){
		// 	e.preventDefault();
		// 	$('body').toggleClass('is-search-menu-visible');
		// 	return false;
		// });
		
		//Prevent certain elements from triggering drags
		var excludedElements = ['a'];
		var excludedClasses = ['.top-menu-items-holder'];
		$('body').off('touchmove.exclude').on('touchmove.exclude',function(e){
			//If excluded element or has excluded class or child of element with excluded class
			if(excludedElements.indexOf($(e.target).get(0).tagName.toLowerCase()) != -1 || (excludedClasses && $(e.target).is(excludedClasses.join(","))) || (excludedClasses && $(e.target).closest(excludedClasses.join(",")).length > 0)){
				e.preventDefault();
			}
		});


		//Listen for tab open or closed
		var hidden, visibilityState, visibilityChange;

		if (typeof document.hidden !== "undefined") {
			hidden = "hidden", visibilityChange = "visibilitychange", visibilityState = "visibilityState";
		} else if (typeof document.mozHidden !== "undefined") {
			hidden = "mozHidden", visibilityChange = "mozvisibilitychange", visibilityState = "mozVisibilityState";
		} else if (typeof document.msHidden !== "undefined") {
			hidden = "msHidden", visibilityChange = "msvisibilitychange", visibilityState = "msVisibilityState";
		} else if (typeof document.webkitHidden !== "undefined") {
			hidden = "webkitHidden", visibilityChange = "webkitvisibilitychange", visibilityState = "webkitVisibilityState";
		} // if

		var document_hidden = document[hidden];

		document.addEventListener(visibilityChange, function() {
		if(document_hidden != document[hidden]) {
		  if(document[hidden]) {
		    // Tab blurred. Do nothing. Or do all kinds of amazing stuff....
		  } else {
				//Dispatch resizeevent to ensure overflows and sizes are respected on tab enter
				//Fixes a quirk in Chrome where we can scroll after tab re-enter
				var evt = document.createEvent("HTMLEvents");
				evt.initEvent("resize", false, true);
				window.dispatchEvent(evt);
		  }

		  document_hidden = document[hidden];
		}
		});
	});

	$(window).load(function(){
		
	});
})( jQuery );
